const actionTypes = {
    GET_TABLE_META_PROPERTIES_SUCCESS: 'GET_TABLE_META_PROPERTIES_SUCCESS',
    GET_TABLE_META_PROPERTIES_REFRESH_SUCCESS: 'GET_TABLE_META_PROPERTIES_REFRESH_SUCCESS',
    GET_SOURCE_EXPLORER_VIEWS_SUCCESS: 'GET_SOURCE_EXPLORER_VIEWS_SUCCESS',
    GET_RECON_EXPLORER_VIEWS_SUCCESS: 'GET_RECON_EXPLORER_VIEWS_SUCCESS',
    CLEAN_EXPLORER_VIEWS: 'CLEAN_EXPLORER_VIEWS',
    GET_VIEW_RECORDS_SUCCESS: 'GET_VIEW_RECORDS_SUCCESS',
    GET_VIEW_SUCCESS: 'GET_VIEW_SUCCESS',
    GET_FILES_FROM_SERVER: 'GET_FILES_FROM_SERVER',
    GET_FILES_FROM_CONTAINER: 'GET_FILES_FROM_CONTAINER',
    SET_LINKED_DATA: 'SET_LINKED_DATA',
    GET_TABLE_META_PROPERTIES_SUCCESS_HISTORY: 'GET_TABLE_META_PROPERTIES_SUCCESS_HISTORY',
};

export default actionTypes;
